<template>
    <div style="background-color: #f9f9f9;">
        <Header />
        <div class="container">
            <!-- 面包屑导航 -->
            <div class="breadcrumb">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item @click.native="$router.push({ name: 'home' })">采购大厅</el-breadcrumb-item>
                    <el-breadcrumb-item @click.native="$router.go(-1)">采购单详情</el-breadcrumb-item>
                    <el-breadcrumb-item>采购报价</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="purchase-info">
                <div class="distance-row" >
                    <span>距离：</span>
                    <span class="distance-value">{{ distance }}</span>
                </div>
                <el-table :data="goods_arr" border style="width: 100%">
                    <el-table-column prop="name" label="商品名称" />
                    <el-table-column prop="num" label="采购数量" />
                    <el-table-column label="可接受采购误差">
                        <template slot-scope="scope">
                            ±{{ scope.row.error_range }}{{ scope.row.unit }}
                        </template>
                    </el-table-column>
                    <el-table-column label="平台参考价">
                        <template slot-scope="scope">
                            ±{{ scope.row.refer_price }}{{ scope.row.unit }}
                        </template>
                    </el-table-column>
                    <el-table-column label="报价折扣率">
                        <template slot-scope="scope">
                            <el-select v-model="scope.row.discount" placeholder="请选择" @change="updatePrice(scope.row)">
                                <el-option v-for="item in discountOptions" :key="item.value" :label="item.value"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="我的报价单价">
                        <template slot-scope="scope">
                            <div style="display: flex; align-items: center;">
                                <span>￥</span>
                                <el-input v-model="scope.row.price" type="number" placeholder="请输入报价" style="flex: 1;"
                                    @input="updateDiscount(scope.row)" />
                                <span>/{{ scope.row.unit }}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="stock" label="我的库存量" />
                </el-table>
                <div class="feeBox">
                    <span>运费价格：</span>
                    <el-input v-model="shipping_fee" type="number" placeholder="请输入运费" min="1" />
                </div>
            </div>
            <!-- 立即报价按钮 -->
            <div class="quote-btn-container">
                <el-button class="quote-btn" type="primary" @click="confirmQuote">确认报价</el-button>
            </div>
        </div>
        <Footer />
    </div>
</template>
<script>
import Header from '../../components/Header.vue'
import Footer from '../../components/Footer.vue'
export default {
    name: 'PurchaseQuotation',
    components: {
        Header,
        Footer
    },
    data() {
        return {
            aid: '', // 采购单ID
            // 采购报价表单数据
            purchaseDetails: {
                address_info: {
                    detail: ''
                },
                needs: '',
                settle_type_name: '',
                title: '',
                goods_list: []
            },
            discountOptions: [], // 报价折扣率选项
            goods_arr: [], // 商品列表，包含折扣信息
            shipping_fee: '', // 运费
            distance: '', // 距采购方直线距离
        }
    },
    mounted() {
        this.aid = this.$route.query.aid;
        this.getPurchaseDetails();
        this.getDiscount();
    },
    methods: {
        // 更新报价
        updatePrice(row) {
            const discount = parseFloat(row.discount);
            const referPrice = parseFloat(row.refer_price);
            if (!isNaN(discount) && !isNaN(referPrice)) {
                row.price = (referPrice * discount).toFixed(2);
            }
        },
        // 更新折扣率
        updateDiscount(row) {
            const price = parseFloat(row.price);
            const referPrice = parseFloat(row.refer_price);
            if (!isNaN(price) && !isNaN(referPrice)) {
                row.discount = (price / referPrice).toFixed(2);
            }
        },
        // 提交报价
        confirmQuote() {
            console.log("this.goods_arr", this.goods_arr);
            let arr1 = this.goods_arr.filter(item => item.price != '');
            if (arr1.length == 0) return this.$message.info('请填写金额');
            if (!this.shipping_fee) return this.$message.info('请输入运费');
            let arr = arr1.map(item => {
                return {
                    goods_id: item.aid,
                    price: item.price,
                    discount: item.discount,
                    goods_category_id: item.goods_category_id,
                }
            })
            this.$api.submitQuotation({
                goods_info: JSON.stringify(arr),
                aid: this.aid,
                shipping_fee: this.shipping_fee,
            }).then(res => {
                this.$message.success('报价成功');
                setTimeout(() => {
                    
                }, 1000);
            }).catch(err => {
                this.$message.error(err);
            })
        },
        getPurchaseDetails() {
            this.$api.purchaseDetails({
                aid: this.aid
            }).then(res => {
                this.purchaseDetails = res;
                let arr = [...this.purchaseDetails.my_goods];
                arr.forEach(item => {
                    item.discount = (item.price / item.refer_price).toFixed(2);
                })
                this.goods_arr = arr;
                this.computeDistance(res.lat,res.lng);
                console.log("this.goods_arr", this.goods_arr);
            }).catch(err => {
                this.$message.error(err);
            })
        },
        getDiscount() {
            this.$api.discountQuotation().then(res => {
                this.discountOptions = res;
            }).catch(err => {
                this.$message.error(err);
            })
        },
        // 计算当前用户到采购方的直线距离（Haversine 公式）
        computeDistance(buyerLat, buyerLng) {
            console.log(buyerLat, buyerLng)
            this.distance = '';
            if (buyerLat == null || buyerLng == null) return;
            let myLoc = {};
            try {
                myLoc = JSON.parse(localStorage.getItem('locationInfo') || '{}');
            } catch (e) {
                myLoc = {};
            }
            console.log("myLoc", myLoc);    
            if (myLoc.lat == null || myLoc.lng == null) return;
            const d = this.getDistance(
                Number(myLoc.lat), Number(myLoc.lng),
                Number(buyerLat), Number(buyerLng)
            );
            this.distance = d < 1 ? Math.round(d * 1000) + ' m' : d.toFixed(1) + ' km';
        },
        // 经纬度直线距离（单位：km）
        getDistance(lat1, lng1, lat2, lng2) {
            console.log("lat1, lng1, lat2, lng2", lat1, lng1, lat2, lng2);
            const R = 6371; // 地球半径 km
            const toRad = d => (d * Math.PI) / 180;
            const dLat = toRad(lat2 - lat1);
            const dLng = toRad(lng2 - lng1);
            const a =
                Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
                Math.sin(dLng / 2) * Math.sin(dLng / 2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return R * c;
        }
    }
}

</script>

<style scoped>
.container {
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
}

.breadcrumb {
    margin-bottom: 20px;
    font-size: 14px;
    color: #666;
}

.breadcrumb .active {
    color: #333;
    font-weight: bold;
}

.arrow {
    margin: 0 5px;
}

.purchase-info,
.purchase-products {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
}

.info-header {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
}

.info-title {
    font-size: 16px;
    margin: 0;
    font-weight: bold;
}

.blue-line {
    display: inline-block;
    width: 3px;
    height: 16px;
    background-color: #1890ff;
    margin-right: 8px;
    vertical-align: middle;
}

.end-time {
    color: #ff4d4f;
    font-size: 14px;
    margin-left: 20px;
}

.info-content {
    line-height: 1.6;
    text-align: left;
}

.title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
}

.requirement {
    margin-bottom: 10px;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
}

.requirement span:first-child {
    margin-right: 5px;
}

.info-row {
    display: flex;
    gap: 30px;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
}

.products-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 15px;
}

.products-table th,
.products-table td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #e8e8e8;
}

.products-table th {
    background-color: #f0f0f0;
    font-weight: bold;
}

.product-name {
    color: #1890ff;
}

.quote-btn-container {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    margin-bottom: 30px;
}

.quote-btn {
    background-color: #1890ff;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 10px 40px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.quote-btn:hover {
    background-color: #40a9ff;
}

.feeBox {
    display: flex;
    align-items: center;
    margin-top: 20px;
    justify-content: end;
    font-size: 14px;

    .el-input {
        width: 200px;
    }
}

.distance-row {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 16px;
    font-size: 14px;
    color: #666;
}

.distance-value {
    color: #286CED;
    font-weight: bold;
}
</style>